package com.eladfinish.bible.contest.ui.components.buttons

import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.border
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.strokeColor
import com.eladfinish.bible.contest.ui.extensions.conditional
import dev.icerock.moko.resources.compose.colorResource

@Composable
fun ItemButtonTextOutline(
    modifier: Modifier = Modifier,
    text: String,
    textColor: Color = Color.White,
    fontSize: TextUnit = 16.sp,
    borderWidth: Int = 1,
    onClick: () -> Unit,
    onLongClick: () -> Unit,
    animateOnLongClick: Boolean = true,
) {
    val haptic = LocalHapticFeedback.current

    var rotationState by remember { mutableStateOf(0f) }
    val rotationValue by animateFloatAsState(
        targetValue = rotationState,
        animationSpec = tween(),
        finishedListener = {
            rotationState = 0f
        }
    )
    val size = 12.dp
    Box(
        modifier = modifier
            .clip(RoundedCornerShape(size))
            .conditional(condition = animateOnLongClick) {
                rotate(degrees = rotationValue)
            }
            .conditional(condition = borderWidth != 0) {
                border(
                    width = borderWidth.dp,
                    color = colorResource(resource = SharedRes.colors.strokeColor),
                    shape = RoundedCornerShape(size),
                )
            }
            .combinedClickable(
                onClick = onClick,
                onLongClick = {
                    haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                    rotationState = 360f
                    onLongClick.invoke()
                },
            ),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            text = text,
            fontSize = fontSize,
            style = MaterialTheme.typography.labelLarge,
            textAlign = TextAlign.Center,
            color = textColor,
        )
    }
}

@Preview(showBackground = true)
@Composable
private fun ItemButtonTextTestPreview() {
    ItemButtonTextOutline(
        modifier = Modifier
            .size(width = 70.dp, height = 60.dp),
        text = "א",
        textColor = Color.Black,
        fontSize = 22.sp,
        borderWidth = 1,
        onClick = {},
        onLongClick = {},
    )
}
